import { useParams, useToast } from "duck";
import { useUpdateOrganizationMutation } from "requests";
import { FormValues } from "./types";

export const useUpdateOrganization = () => {
  const { id } = useParams();
  const [update] = useUpdateOrganizationMutation({ ignoreResults: true });
  const toast = useToast({
    status: "success",
    description: "Organization is updated successfully."
  });

  return (formValues: FormValues) =>
    update({
      variables: {
        input: {
          _id: +id,
          name: formValues.name,
          contactEmail: formValues.contactEmail,
          description: formValues.description,
          logo:
            typeof formValues.logo === "number"
              ? { _id: formValues.logo }
              : formValues.logo
        }
      }
    }).then(() => toast());
};
